import * as React from "react";
const NewsBlock = (props) => (
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={10.5} cy={10.5} r={10} stroke="#CED5E5" />
    <path d="M18 5L2 16" stroke="#CED5E5" strokeLinecap="round" />
  </svg>
);
export default NewsBlock;
